import axios from 'axios'
// import _ from "lodash"
import treeHandler from '@/services/treeHandler'

import filter from 'lodash/filter'

const state = {
  filter: 0,
  tree: [],
  sportSelectedInToolbarTree: null,
}

const getters = {
  getTree(state) {
    return state.tree
  },

  getFilter(state) {
    return state.filter
  },
  getSportSelectedInToolbarTree(state) {
    return state.sportSelectedInToolbarTree
  },
}

const actions = {
  async setFilter(context, payload) {
    context.commit('SET_FILTER', payload)
  },

  async apiGetSportsTreeV2(context, payload) {
    const language =
      payload.language || context.rootGetters['settings/getLanguage']
    const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-sports`

    // Get Tree
    return await axios.post(
      `${url}`,
      {
        filter: payload.filter,
        id_language: language,
      },
      {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      }
    )
  },

  async fetchTreeV2Complete(context, payload) {
    const language = context.rootGetters['settings/getLanguage']

    const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-sports`

    // Get Tree
    await axios
      .post(
        `${url}`,
        {
          filter: state.filter,
          id_language: language,
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )

      .then(async res => {
        const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
        const managerRules = context.rootGetters['rules/getRulesManager']
        if (!onlyManager) {
          var skinRules = context.rootGetters['rules/getRulesSkin']
        }

        //todo delete rules that not interesting the sport
        const rulesSchema = {
          sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
          categoryManager:
            filter(managerRules, { scope: 'category' }).length > 0,
          tournamentManager:
            filter(managerRules, { scope: 'tournament' }).length > 0,
          eventManager:
            filter(managerRules, { scope: 'event', type: 'disable' }).length >
            0,
          sportSkin:
            !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
          categorySkin:
            !onlyManager && filter(skinRules, { scope: 'category' }).length > 0,
          tournamentSkin:
            !onlyManager &&
            filter(skinRules, { scope: 'tournament' }).length > 0,
          eventSkin:
            filter(managerRules, { scope: 'event', type: 'disable' }).length >
            0,
        }

        const rules = {
          manager: managerRules,
          skin: !onlyManager ? skinRules : [],
        }

        const tree = await treeHandler.refactorSports(
          res.data.sports,
          rules,
          rulesSchema,
          language
        )
        const treeAntepost = await treeHandler.refactorSports(
          res.data.sportsAntepost,
          rules,
          rulesSchema,
          language
        )

        tree.push({
          count: 0,
          icon_id: 9999,
          id: '9999#antepost',
          name: 'Antepost',
          order: 9999,
          type: 'antepost_root',
          typeOdds: 'antepost',
          children: treeAntepost,
        })

        context.commit('setTree', tree)
      })
      .catch(err => {
        console.log(err)
      })
  },

  async fetchCategoryTreeForSport(context, payload) {
    const language = context.rootGetters['settings/getLanguage']
    const sportId = payload.sportId

    const sportToFind = state.tree.find(sport => {
      return sport.sportId === sportId
    })

    if (sportToFind.children == null || sportToFind.children.length === 0) {
      const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-category-for-sport`

      await axios
        .post(
          `${url}`,
          {
            sportId: sportId,
            filter: state.filter,
            language: language,
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
            },
          }
        )

        .then(async res => {
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const managerRules = context.rootGetters['rules/getRulesManager']
          if (!onlyManager) {
            var skinRules = context.rootGetters['rules/getRulesSkin']
          }

          //todo delete rules that not interesting the categories
          const rulesSchema = {
            sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
            categoryManager:
              filter(managerRules, { scope: 'category' }).length > 0,
            tournamentManager:
              filter(managerRules, { scope: 'tournament' }).length > 0,
            eventManager:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
            sportSkin:
              !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
            categorySkin:
              !onlyManager &&
              filter(skinRules, { scope: 'category' }).length > 0,
            tournamentSkin:
              !onlyManager &&
              filter(skinRules, { scope: 'tournament' }).length > 0,
            eventSkin:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
          }

          const rules = {
            manager: managerRules,
            skin: !onlyManager ? skinRules : [],
          }

          if (res && res.data && res.data.categories) {
            const categoriesTree = await treeHandler.refactorCategories(
              res.data.categories,
              rules,
              rulesSchema,
              language
            )
            const saveTree = state.tree

            context.commit('setTree', [])

            const sportToModify = saveTree.find(sport => {
              return sport.icon_id === sportId
            })

            if (sportToModify) {
              sportToModify.children = categoriesTree
            }

            context.commit('setTree', saveTree)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  async fetchTournamentsTreeForCategory(context, payload) {
    const language = context.rootGetters['settings/getLanguage']
    const sportId = payload.sportId
    const categoryId = payload.categoryId

    const foundSport = state.tree.find(sport => {
      return sport.sportId === sportId
    })

    const foundCategory = foundSport.children.find(category => {
      return category.categoryId === categoryId
    })

    if (foundCategory.children == null || foundCategory.children.length === 0) {
      const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-tournaments-for-sport-category`

      await axios
        .post(
          `${url}`,
          {
            sportId: sportId,
            categoryId: categoryId,
            filter: state.filter,
            language: language,
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
            },
          }
        )

        .then(async res => {
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const managerRules = context.rootGetters['rules/getRulesManager']
          if (!onlyManager) {
            var skinRules = context.rootGetters['rules/getRulesSkin']
          }

          const rulesSchema = {
            sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
            categoryManager:
              filter(managerRules, { scope: 'category' }).length > 0,
            tournamentManager:
              filter(managerRules, { scope: 'tournament' }).length > 0,
            eventManager:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
            sportSkin:
              !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
            categorySkin:
              !onlyManager &&
              filter(skinRules, { scope: 'category' }).length > 0,
            tournamentSkin:
              !onlyManager &&
              filter(skinRules, { scope: 'tournament' }).length > 0,
            eventSkin:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
          }

          const rules = {
            manager: managerRules,
            skin: !onlyManager ? skinRules : [],
          }

          if (res && res.data && res.data.tournaments) {
            const saveTree = state.tree
            const treeTournaments = await treeHandler.refactorTournaments(
              res.data.tournaments,
              rules,
              rulesSchema,
              language
            )

            context.commit('setTree', [])

            const sportToModify = saveTree.find(sport => {
              return sport.icon_id === sportId
            })

            if (sportToModify) {
              const catToModify = sportToModify.children.find(category => {
                return category.categoryId === categoryId
              })

              if (catToModify != null) {
                catToModify.children = treeTournaments
              }
            }

            context.commit('setTree', saveTree)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  async fetchAntepostCategoryTreeForSport(context, payload) {
    const language = context.rootGetters['settings/getLanguage']
    const sportId = payload.sportId

    const antepostGroup = state.tree.find(sport => {
      return sport.id === '9999#antepost'
    })

    const sportGroup = antepostGroup.children.find(sport => {
      return sport.sportId === sportId
    })

    if (sportGroup.children == null || sportGroup.children.length === 0) {
      const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-category-for-sport-antepost`

      await axios
        .post(
          `${url}`,
          {
            sportId: sportId,
            filter: state.filter,
            language: language,
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
            },
          }
        )

        .then(async res => {
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const managerRules = context.rootGetters['rules/getRulesManager']
          if (!onlyManager) {
            var skinRules = context.rootGetters['rules/getRulesSkin']
          }

          //todo delete rules that not interesting the categories
          const rulesSchema = {
            sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
            categoryManager:
              filter(managerRules, { scope: 'category' }).length > 0,
            tournamentManager:
              filter(managerRules, { scope: 'tournament' }).length > 0,
            eventManager:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
            sportSkin:
              !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
            categorySkin:
              !onlyManager &&
              filter(skinRules, { scope: 'category' }).length > 0,
            tournamentSkin:
              !onlyManager &&
              filter(skinRules, { scope: 'tournament' }).length > 0,
            eventSkin:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
          }

          const rules = {
            manager: managerRules,
            skin: !onlyManager ? skinRules : [],
          }

          if (res && res.data && res.data.categories) {
            const categoriesTree = await treeHandler.refactorCategories(
              res.data.categories,
              rules,
              rulesSchema,
              language
            )
            const saveTree = state.tree

            context.commit('setTree', [])

            const sportToModify = antepostGroup.children.find(sport => {
              return sport.icon_id === sportId
            })

            sportToModify.children = categoriesTree
            context.commit('setTree', saveTree)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  async fetchAntepostTournamentsTreeForSport(context, payload) {
    const sportId = payload.sportId
    const categoryId = payload.categoryId
    const language = context.rootGetters['settings/getLanguage']

    const antepostGroup = state.tree.find(sport => {
      return sport.id === '9999#antepost'
    })

    const sportGroup = antepostGroup.children.find(sport => {
      return sport.sportId === sportId
    })

    const categoryFound = sportGroup.children.find(category => {
      return category.categoryId === categoryId
    })

    if (categoryFound.children == null || categoryFound.children.length === 0) {
      const url = `${context.rootGetters['settings/getUrlApi']}/api/tree/v2/get-tournaments-for-sport-category-antepost`

      await axios
        .post(
          `${url}`,
          {
            sportId: sportId,
            categoryId: categoryId,
            filter: state.filter,
            language: language,
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
            },
          }
        )

        .then(async res => {
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const managerRules = context.rootGetters['rules/getRulesManager']
          if (!onlyManager) {
            var skinRules = context.rootGetters['rules/getRulesSkin']
          }

          //todo delete rules that not interesting the tournaments
          const rulesSchema = {
            sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
            categoryManager:
              filter(managerRules, { scope: 'category' }).length > 0,
            tournamentManager:
              filter(managerRules, { scope: 'tournament' }).length > 0,
            eventManager:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
            sportSkin:
              !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
            categorySkin:
              !onlyManager &&
              filter(skinRules, { scope: 'category' }).length > 0,
            tournamentSkin:
              !onlyManager &&
              filter(skinRules, { scope: 'tournament' }).length > 0,
            eventSkin:
              filter(managerRules, { scope: 'event', type: 'disable' }).length >
              0,
          }

          const rules = {
            manager: managerRules,
            skin: !onlyManager ? skinRules : [],
          }

          if (res && res.data && res.data.tournaments) {
            const tournamentsTree =
              await treeHandler.refactorTournamentsAntepost(
                res.data.tournaments,
                rules,
                rulesSchema,
                language
              )
            const saveTree = state.tree
            context.commit('setTree', [])

            categoryFound.children = tournamentsTree
            context.commit('setTree', saveTree)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },

  async findEventMin(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/findquickminv2`

    if (payload.search != null && payload.search != '') {
      return await axios
        .post(
          `${url}`,
          {
            search: payload.search,
            lang: payload.lang,
            sport: payload.sport,
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
            },
          }
        )
        .then(async res => {
          if (res.data.events) {
            return res.data.events
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },

  async fetchMarketSportQuickbet(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-quickbet-event`

    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
      .then(async res => {
        return res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchOutcomesByMarket(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-outcomes-market-event`

    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
      .then(async res => {
        return res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
  async setSportSelectedInToolbarTree(context, payload) {
    context.commit('SET_SPORT_SELECTED_IN_TOOLBAR_TREE', payload)
  },
}

const mutations = {
  setTree(state, payload) {
    state.tree = payload
  },
  SET_FILTER(state, payload) {
    state.filter = payload
  },
  SET_SPORT_SELECTED_IN_TOOLBAR_TREE(state, payload) {
    state.sportSelectedInToolbarTree = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
